import Text from '../../../Text'
import React from 'react'
import styles from './styles.module.css'
import CheckmarkIcon from '../../../icons/CheckmarkIcon'
import CloseIcon from '../../../icons/CloseIcon'
import ConnectingDashIcon from '../../../icons/ConnectingDashIcon'

function FeaturesList({ features }) {
  return (
     <div className={styles.featuresWrapper}>
       { features.map(f => renderFeature(f)) }
     </div>
  )
}

const renderFeature = (feature) => {
  return (
    <div className={styles.featureWrapper} key={feature.name}>
      <div className={feature.isIncluded ? styles.featureTitleWrapper : `${styles.featureTitleWrapper} ${styles.featureTitleWrapperExcluded}`}>
        <div className={styles.featureIconWrapper}>
          { feature.isIncluded ? <CheckmarkIcon color="currentColor"/> : <CloseIcon color="currentColor"/> }
        </div>
        <Text type="body-short-1">{feature.name}</Text>
      </div>

      {
        feature.optionA && feature.optionB && (
          <div className={styles.featureOptionsWrapper}>
            <div className={styles.featureOption}>
              <Text type="caption-1">{feature.optionA}</Text>
            </div>
            <div className={styles.connectingDashIconWrapper}>
              <ConnectingDashIcon/>
            </div>
            <Text type="caption-1">OR</Text>
            <div className={styles.connectingDashIconWrapper}>
              <ConnectingDashIcon/>
            </div>
            <div className={styles.featureOption}>
              <Text type="caption-1">{feature.optionB}</Text>
            </div>
          </div>
        )
      }
    </div>
  )
}

export default FeaturesList
